import { cn } from '@core/utils';

import { REGIONS_DATA } from '../../constants';

type RegionItemProps = {
  region: string;
  cities: string;
  showBorder: boolean;
};

const RegionItem = ({ region, cities, showBorder }: RegionItemProps) => {
  return (
    <div
      className={cn(
        'flex gap-10 rounded-xsmall p-8 typo-caption1',
        showBorder && 'border-b border-B-50',
      )}
      role="listitem"
    >
      <p className="w-40 font-700 text-Gray-800">{region}</p>
      <p className="flex-1 font-600 text-Gray-600">{cities}</p>
    </div>
  );
};

export const RegionListContent = () => {
  return (
    <>
      <p className="flex w-full items-center justify-center rounded-xsmall bg-B-100 py-8 font-800 text-Gray-800">
        10개 지역 구분 안내 📍
      </p>
      <div
        className="flex w-full flex-col"
        role="list"
        aria-label="지역별 스탬프 구분 안내"
      >
        {REGIONS_DATA.map((item, index) => (
          <RegionItem
            key={item.region}
            region={item.region}
            cities={item.cities}
            showBorder={index !== REGIONS_DATA.length - 1}
          />
        ))}
      </div>
    </>
  );
};
